import { render, staticRenderFns } from "./vcNotification.vue?vue&type=template&id=003d4902&scoped=true&"
import script from "./vcNotification.vue?vue&type=script&lang=js&"
export * from "./vcNotification.vue?vue&type=script&lang=js&"
import style0 from "./vcNotification.vue?vue&type=style&index=0&id=003d4902&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003d4902",
  null
  
)

export default component.exports